export const DROPDOWN_TYPES = "dropdown";
export const DROPDOWN_TYPES_MONTHS = "monthdropdown";
export const DATE_TYPES = "date";
export const CHECKBOX_TYPES = "checkbox";
export const GROUP_CHECKBOX = "groupcheckbox";
export const SSN = "ssn";
export const EIN = "ein";
export const PHONE_NUMBER = "phone";
export const RADIO = "radio";
export const ONE_TO_MANY_RADIO = "multiradio";
export const CURRENCY = "currency";
export const NUMBER = "number";
export const CONTAINER = "container";
export const PERCENT = "percent";
export const VOID = "void";
export const HYPERLINK = "hyperlink";
export const EDITABLE_HYPERLINK = "editablehyperlink";
export const MULTILINE_TEXTFIELD = "multiline";
export const DROPDOWN_WITH_TEXTFIELD = "dropdownwithtextfield";
export const DROPDOWN_WITH_CHECKBOXFIELD = "dropdownwithcheckboxfield";
export const ALPHANUMERIC = "alphanumeric";
export const DUMMY = "dummy";
export const AUTOCOMPLETE_ADDRESS = "autocompleteaddress";
export const AUTOCOMPLETE_ZIPCODE = "autocompletezipcode";
export const STATE_AUTOCOMPLETE = "stateautocomplete";
export const CARDRADIO ="cardradio";
export const TOGGLE = "toggle";
export const HORIZONTAL_LINE = "horizontalline";
export const PASSWORD = "password";
export const TEXTAREA = "textarea";

export const BorrowerCategory = {
  P: " Primary Borrower",
  C: " Co Borower",
  G: " Primary Gurantor",
  A: " Guarantor"
};
